module.exports = __webpack_public_path__ + "img/rho-17-bienenwachs-01.522f877c.jpeg";